import { LocaleMessages, setLocaleMessages } from '@uikit/ui-kit';
import { I18n } from './I18n';
import { Loader, LocaleLoader, createLocaleLoader } from './LocaleLoader';

export async function setupLocale(i18n: I18n, loader: Loader<LocaleMessages>, locale: string): Promise<void> {
  const localeLoader: LocaleLoader = createLocaleLoader();
  const uiKitLocaleLoader: LocaleLoader = createLocaleLoader();
  const [localeMessages, uiKitLocaleMessages]: Array<LocaleMessages | null> = await Promise.all([
    localeLoader.load(loader, locale),
    uiKitLocaleLoader.load(async () => (await import(`@uikit/ui-kit/lib/locale/lang/${locale}`)).default, locale)
  ]);

  if (localeMessages) {
    i18n.locale = locale;
    i18n.mergeLocaleMessage(locale, localeMessages);
  }

  if (uiKitLocaleMessages) {
    setLocaleMessages(uiKitLocaleMessages);
  }
}
